// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldProperties.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import ButtonCheck from 'share/components/controls/Izenda.ButtonCheck';

/**
 * CalculatedFieldProperties Component
 */
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var action = require('./Izenda.CalculatedFieldPropertiesAction');

  var CalculatedFieldProperties = React.createClass({
    getDefaultProps: function() {
      return {
        requireLabel: true
      };
    },

    render: function() {
      var props = this.props;
      props.uiState.update(this.props);
      return (
        <div className="expression-input">
          <ButtonCheck
            hasValue={props.uiState.hadSetting}
            onClick={props.showPopup}
            title={props.title}
            disabled={props.disabled}
            className={props.className} />
          {props.uiState.hadSetting &&
            <span>
              <i
                className="icon-cancel u-colorRed"
                title={props.localization.getText(
                  'PROPERTIES_EDITOR_REMOVE_SETTING'
                )}
                onClick={props.fnResetDefaultValue}
              />
            </span>}
        </div>
      );
    }
  });

  module.exports = connect(action)(CalculatedFieldProperties);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.CalculatedFieldProperties.jsx